const isHtmlResponse = (data: unknown): boolean =>
  typeof data === 'string' && /<!doctype html>/i.test(data);

const ensureValidAPISessionResponse = (
  data: unknown,
  setIsAuthenticated: (value: boolean) => void,
  navigate: (path: string) => void
): boolean => {
  if (isHtmlResponse(data)) {
    setIsAuthenticated(false);
    navigate('/');
    return false;
  }
  return true;
};

export default ensureValidAPISessionResponse;
